import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import { h5PageCount } from 'ThreeTerminal_utils';
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
import { WxLaunchApp, UpgradeBottomSlides } from 'ThreeTerminal_mobile_dynamic';

class BottomSlide extends React.PureComponent {
    static propTypes = {
        noCloseIcon: PropTypes.bool,
        slidesConfig: PropTypes.object,
        base62Id: PropTypes.string,
        wxLaunch: PropTypes.object,
        isVideoShare: PropTypes.bool,
        pageBottomPic: PropTypes.object,
        classV: PropTypes.array,
        ad: PropTypes.object,
    };

    componentDidMount() {
        const { base62Id, pageBottomPic } = this.props;
        const activityImage = pageBottomPic?.videoShare?.imageUrl;

        if (activityImage) {
            h5PageCount([
                {
                    behavior: 'pageinfo',
                    type: 'hot_dopen',
                    other: [`ucms_${base62Id}`, 'video'],
                },
            ]);
        }
    }

    activityHandle = (isSendCount = true, isJumpQQlink = false, isCall = true) => {
        const { base62Id, pageBottomPic } = this.props;
        const schemeUrl = (pageBottomPic?.videoShare?.jumpMode === 2 && pageBottomPic?.videoShare?.url) || '';

        h5PageCount([
            {
                behavior: 'action',
                type: 'hot_dopen',
                other: {
                    ref: `ucms_${base62Id}`,
                    url: encodeURIComponent(location.href),
                    kind: 'video',
                },
            },
        ]);

        if (isCall) {
            if (schemeUrl) {
                callApp({
                    docType: 'custom',
                    pid: schemeUrl,
                    download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1473191849934',
                    downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8821',
                    isJumpQQlink,
                });
            } else {
                location.href = pageBottomPic?.videoShare?.url;
            }
        }
    };

    isOpenOperateHandle = () => {
        const { pageBottomPic, classV } = this.props;
        const isOpen = pageBottomPic?.videoShare?.isOpen;
        const hasChannelRange = pageBottomPic?.videoShare?.hasChannelRange;
        const channelRange = pageBottomPic?.videoShare?.channelRange;

        if (isOpen) {
            if (hasChannelRange) {
                let flag = false;

                channelRange.split(',').forEach((item) => {
                    if (!flag && classV.join(',').includes(item)) {
                        flag = true;
                    }
                });

                return flag;
            }

            return true;
        }

        return false;
    };

    render() {
        const { wxLaunch, noCloseIcon, slidesConfig, isVideoShare, pageBottomPic, base62Id, ad } = this.props;
        const wxLaunchSwitch = wxLaunch.wxLaunchSwitch;
        const schemeUrl = (pageBottomPic?.videoShare?.jumpMode === 2 && pageBottomPic?.videoShare?.url) || '';
        const schemeLink = schemeUrl
            ? getSchemeLink({
                  docType: 'custom',
                  pid: schemeUrl,
              })
            : '';

        return (
            <React.Fragment>
                {this.isOpenOperateHandle() ? (
                    <div className={styles.activityBox}>
                        <section className={styles.fixBottom} onClick={this.activityHandle}>
                            <img className={styles.activityImage} src={pageBottomPic?.videoShare?.imageUrl} />
                            {wxLaunchSwitch && schemeUrl && !isVideoShare && (
                                <WxLaunchApp
                                    launchType="app"
                                    launchAppClick={this.activityHandle.bind(this, true, false, false)}
                                    schemeLink={schemeLink}
                                    launchAppFail={this.activityHandle.bind(this, false, true, true)}
                                />
                            )}
                        </section>
                    </div>
                ) : (
                    <section className={styles.fixBottom}>
                        <UpgradeBottomSlides noCloseIcon={noCloseIcon} content={slidesConfig} ad={ad} />
                    </section>
                )}
            </React.Fragment>
        );
    }
}

export default errorBoundary(BottomSlide);
